import {BreakpointObserver} from '@angular/cdk/layout';
import {Injectable} from '@angular/core';
import {Capacitor} from '@capacitor/core';
import {Observable, Subscription} from 'rxjs';
import {filter, map, startWith, take} from 'rxjs/operators';
import {getPlatformFromStorage, savePlatformToStorage} from './../localStorage/ls-user-info';

@Injectable({
  providedIn: 'root',
})
export class MobileService {
  constructor(private breakpointObserver: BreakpointObserver) {}

  public observeMobile(): Observable<boolean> {
    return this.breakpointObserver.observe('(max-width: 959px)').pipe(
      map(breakpointState => breakpointState.matches),
      startWith(this.breakpointObserver.isMatched('(max-width: 959px)'))
    );
  }

  public observePhone(): Observable<boolean> {
    return this.breakpointObserver.observe('(max-width: 550px)').pipe(
      map(breakpointState => breakpointState.matches),
      startWith(this.breakpointObserver.isMatched('(max-width: 550px)'))
    );
  }

  private observeSingleSwitch(nextMobile: boolean): Observable<boolean> {
    return this.observeMobile().pipe(
      filter(mobile => mobile === nextMobile),
      take(1)
    );
  }

  public observeSingleDesktopSwitch(): Observable<boolean> {
    return this.observeSingleSwitch(false);
  }

  public subscribeToDesktopSwitch(callback: () => void): Subscription {
    return this.observeSingleDesktopSwitch().subscribe(callback);
  }

  public observeSingleMobileSwitch(): Observable<boolean> {
    return this.observeSingleSwitch(true);
  }

  public subscribeToMobileSwitch(callback: () => void): Subscription {
    return this.observeSingleMobileSwitch().subscribe(callback);
  }

  public isMobilePlatform(): boolean {
    const platform = this.getMobilePlatform();
    return platform !== null;
  }

  public getMobilePlatform(): 'ios' | 'android' | null {
    // Check localStorage first
    const stored = getPlatformFromStorage();
    if (stored) return stored;

    // Detect and cache platform
    const platform = Capacitor.getPlatform();
    if (platform === 'ios' || platform === 'android') {
      savePlatformToStorage(platform);
      return platform;
    }

    return null;
  }
}
